import React from 'react';

import PropTypes from 'prop-types';

import { Table, TableBody, TableCell, TableRow, Typography } from '@mui/material';

import { StyledPaper, TableWrapper } from './styles';

const BoxRenderer = ({ box }) => {
    const maxRows = Math.max(...box.columns.map((col) => col.rows.length));

    const rows = Array.from({ length: maxRows }, (_, rowIndex) => {
        const cells = box.columns.map((column, colIndex) => {
            const row = column.rows.find((r) => r.row_order === rowIndex + 1);
            const isBold = row?.cell_type === 'bold';
            const isHeader = row?.cell_type === 'header';
            const isFooter = row?.cell_row_type === 'footer';
            const cell = isHeader ? row?.cell : null;
            const value = row?.formatted_value || row?.value || cell || '';

            const align =
                box.columns.length === 2 ? (colIndex === 0 ? 'left' : 'right') : column.column_type === 'header' ? 'left' : 'right';

            return (
                <TableCell
                    key={column.column_order}
                    align={align}
                    sx={{
                        fontWeight: isBold || isHeader || isFooter ? 'bold' : 'normal',
                        color: isHeader ? '#3A6647' : 'inherit',
                        backgroundColor: isFooter ? '#F0F1F3' : '#FFFFFF',
                        borderBottom: '1px solid #e0e0e0',
                        textAlign: column.column_type === 'header' ? 'left' : 'center',
                        minWidth: 100,
                        ...(colIndex === 0 && {
                            position: 'sticky',
                            left: 0,
                            zIndex: 1 // Se quiser reforçar: zIndex: isHeader ? 3 : 1
                        })
                    }}
                >
                    {value !== 'header' ? value : null}
                </TableCell>
            );
        });

        return <TableRow key={rowIndex}>{cells}</TableRow>;
    });

    return (
        <StyledPaper elevation={3}>
            <Typography variant="h6" gutterBottom sx={{ color: 'darkgreen', fontWeight: 'bold', textAlign: 'center' }}>
                {box.name}
            </Typography>

            <TableWrapper>
                <Table>
                    <TableBody>{rows}</TableBody>
                </Table>
            </TableWrapper>
        </StyledPaper>
    );
};

BoxRenderer.propTypes = {
    box: PropTypes.shape({
        name: PropTypes.string.isRequired,
        columns: PropTypes.arrayOf(
            PropTypes.shape({
                column_order: PropTypes.number.isRequired,
                column_type: PropTypes.string,
                rows: PropTypes.arrayOf(
                    PropTypes.shape({
                        row_order: PropTypes.number.isRequired,
                        cell_type: PropTypes.string,
                        cell_row_type: PropTypes.string,
                        value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
                        formatted_value: PropTypes.string,
                        cell: PropTypes.string
                    })
                ).isRequired
            })
        ).isRequired
    }).isRequired
};

export default BoxRenderer;
